import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import {
  BigNumber,
  Long,
  TradingGroupImpl,
  OrderIntent,
  OrderState,
  CurrencyImpl,
  PositionUnit,
  BenchmarkOrderType,
  OrderType,
  Tenor,
  moment,
} from "shared/cubiq-model-multi-asset";
import { BmarkOrderData } from "shared/cubiq-services/model/benchmarks/BmarkOrderData.model";
import { TraderGroupLookupService } from "../TraderGroupLookupService";
import { CcyLookupService } from "../CcyLookupService";
import { ActivatedRoute } from "@angular/router";
import { BENCHMARK_TERMINAL_STATE } from "../../../../model/benchmarks/BmarkTerminalState.const";
import { BmarkRiskData } from "shared/cubiq-services/model/benchmarks/BmarkRiskData.model";
import {
  BMRiskUtils,
  RiskAggregate,
} from "shared/cubiq-services/model/benchmarks/helpers/BMRiskUtils";
import { ValueDateHelper } from "shared/cubiq-services/model/orders/ValueDateHelper";
import { ZERO } from "shared/base-components/number-spinner.component";
import { LoggerServiceRef } from "@bfx/logger/dist/src/LoggerService";

/**
 * More of collection of common/sahred interfaces used and exposed by Risk Models
 */
/**
 * Interface that is exposed by SpotRiskModel to types it subscribes to.
 */
export interface RiskBMOrderDataListener {
  onBlotterReload(reason: BLOTTER_RELOAD_TYPE, type: RiskSubscriptionType);
  onUpdateOrders(update: Set<BmarkOrderData>, type: RiskSubscriptionType);
  onRemoveOrders(remove: Set<BmarkOrderData>, type: RiskSubscriptionType, filter: boolean);
}

/**
 * Implemented by classes that wish to lsten to the changes to the Spot or Fwd aggregates models
 */
export interface RiskModelDataListener {
  onBlotterReload(reason: BLOTTER_RELOAD_TYPE);
  onUpdatePairs(update: Set<string>);
  onRemovePairs(remove: Set<string>);
}

export enum BLOTTER_RELOAD_TYPE {
  INIT,
  FIXING_CHANGE,
  VIEW_CHANGE,
  FILTER_CHANGE,
}

/**
 * Implemented by classes that will provide data to a Risk Model
 */
export interface BmarkRiskOrderDataProvider {
  primeData(): Promise<Set<BmarkOrderData>>;

  subscribe(type: RiskSubscriptionType, listener: RiskBMOrderDataListener);
}

export enum RiskSubscriptionType {
  CLIENT,
  HEDGE,
}

/**
 * Currently a Nop class but can be used in type checks if needed
 */
export class BaseBMRiskModel {
  public constructor() {}
}
